export type Question = {
  id: string; numero: number; area: string; areaCurta: string; habilidade: string; referencia: string;
  enunciado: string; alternativas: { A: string; B: string; C: string; D: string }; correta: string; justificativa: string;
  numeroOriginal?: number;
  visual?: { sourceUrl: string; sourcePage: number; alt: string };
  visualAlternativas?: { A: string; B: string; C: string; D: string };
  visualAlternativaRemovida?: "A"|"B"|"C"|"D"|"E";
  gabaritoOriginal?: "A"|"B"|"C"|"D"|"E";
  status?: "ativo"|"pendente_visual";
};

import bank from './simulado-bank.json';
import math01 from './matematica-enem-2009-2018-01';
import math02 from './matematica-enem-2009-2018-02';
import math03 from './matematica-enem-2009-2018-03';
import math04 from './matematica-enem-2009-2018-04';
import math05 from './matematica-enem-2009-2018-05';
import math06 from './matematica-enem-2009-2018-06';
import math07 from './matematica-enem-2009-2018-07';
import math08 from './matematica-enem-2009-2018-08';
import math09 from './matematica-enem-2009-2018-09';
import math10 from './matematica-enem-2009-2018-10';
import math11 from './matematica-enem-2009-2018-11';
import math12 from './matematica-enem-2009-2018-12';
import math13 from './matematica-enem-2009-2018-13';
import math14 from './matematica-enem-2009-2018-14';
import math15 from './matematica-enem-2009-2018-15';
import math16 from './matematica-enem-2009-2018-16';
import math17 from './matematica-enem-2009-2018-17';
import math18 from './matematica-enem-2009-2018-18';
import math19 from './matematica-enem-2009-2018-19';
import math20 from './matematica-enem-2009-2018-20';
import math21 from './matematica-enem-2009-2018-21';
import math22 from './matematica-enem-2009-2018-22';
import math23 from './matematica-enem-2009-2018-23';
import math24 from './matematica-enem-2009-2018-24';
import math25 from './matematica-enem-2009-2018-25';
import mathVisual72 from './matematica-enem-visuais-72';

function normalizeQuestionAlternatives(question: Question): Question {
  if (question.visual || !question.gabaritoOriginal) return question;
  const entries = Object.entries(question.alternativas)
    .filter(([letter, value]) => /^[A-E]$/.test(letter) && typeof value === "string");
  if (entries.length !== 4) return question;
  const correctIndex = entries.findIndex(([letter]) => letter === question.gabaritoOriginal);
  if (correctIndex < 0) return question;
  const alternativas = Object.fromEntries(
    entries.map(([, value], index) => [String.fromCharCode(65 + index), value]),
  ) as Question["alternativas"];
  return { ...question, alternativas, correta: String.fromCharCode(65 + correctIndex) };
}

export const questions = [
  ...(bank as Question[]),
  ...math01,
  ...math02,
  ...math03,
  ...math04,
  ...math05,
  ...math06,
  ...math07,
  ...math08,
  ...math09,
  ...math10,
  ...math11,
  ...math12,
  ...math13,
  ...math14,
  ...math15,
  ...math16,
  ...math17,
  ...math18,
  ...math19,
  ...math20,
  ...math21,
  ...math22,
  ...math23,
  ...math24,
  ...math25,
  ...mathVisual72
].filter((question) => question.status !== "pendente_visual")
  .map(normalizeQuestionAlternatives) as Question[];

export const areaSummary = [
  { area: 'Linguagens, Códigos e suas Tecnologias', short: 'Linguagens', count: questions.filter((question) => question.area === 'Linguagens, Códigos e suas Tecnologias').length },
  { area: 'Ciências Humanas e suas Tecnologias', short: 'Ciências Humanas', count: questions.filter((question) => question.area === 'Ciências Humanas e suas Tecnologias').length },
  { area: 'Ciências da Natureza e suas Tecnologias', short: 'Ciências da Natureza', count: questions.filter((question) => question.area === 'Ciências da Natureza e suas Tecnologias').length },
  { area: 'Matemática e suas Tecnologias', short: 'Matemática', count: questions.filter((question) => question.area === 'Matemática e suas Tecnologias').length },
];
